import { getIn } from 'final-form';
import { omit } from 'ramda';

/**
 * Проверяет, содержит ли объект ошибок final-form field-array
 * хотя бы одну непустую ошибку в любой вложенности
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function hasNonEmptyErrorsSimple(errorObj: any): boolean {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const checkObject = (obj: any): boolean => {
    if (!obj || typeof obj !== 'object') return false;

    if (Array.isArray(obj)) {
      return obj.some(item => checkObject(item));
    }

    const keys = Object.keys(obj);

    if (keys.length === 0) return false;

    // Если все значения - объекты/массивы, проверяем их рекурсивно
    // Если есть хотя бы одно не-объектное значение - считаем что есть ошибка

    const hasError = keys.some(key => {
      if (Array.isArray(obj[key]) && !obj[key]['FINAL_FORM/array-error']) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return obj[key].some((itemKey: any) => checkObject(itemKey));
      }

      return (
        (obj[key] && typeof obj[key] === 'object' && Object.values(obj[key]).some(val => typeof val === 'string')) ||
        obj?.[key]?.['FINAL_FORM/array-error'] ||
        typeof obj[key] === 'string'
      );
    });

    if (hasError) return true;

    return keys.some(key => checkObject(obj[key]));
  };

  return checkObject(errorObj);
}

/**
 * Проверяет, есть ли ошибка хотя бы в одном из перечисленных полей.
 *
 * Нужна там, где у блока нет собственного пути в форме и checkHasErrorInCollapseBlock
 * неприменим: пустой путь вернул бы ошибки всей формы.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const checkHasErrorInFields = (errors: any, fieldPaths: string[]): boolean =>
  fieldPaths.some(fieldPath => {
    const fieldError = getIn(errors, fieldPath);

    return typeof fieldError === 'string' ? !!fieldError : hasNonEmptyErrorsSimple(fieldError);
  });

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const checkHasErrorInCollapseBlock = (formRef: any, pathToBlock: string, excludedFields: string[] = []) => {
  const errors = getIn(formRef?.current.getState()?.errors, pathToBlock);
  const errorMeta = omit(excludedFields, errors);

  return hasNonEmptyErrorsSimple(errorMeta);
};
